export const Loader = () => {
  return (
    // <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white dark:bg-zinc-900">
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <span className="w-12 h-12 border-4 border-blue-600 border-b-transparent rounded-full animate-spin"></span>
    </div>
  );
};